var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 5.83301C3.33337 4.6545 3.33337 4.06524 3.69949 3.69912C4.06561 3.33301 4.65487 3.33301 5.83337 3.33301C7.01188 3.33301 7.60114 3.33301 7.96726 3.69912C8.33337 4.06524 8.33337 4.6545 8.33337 5.83301V14.1663C8.33337 15.3448 8.33337 15.9341 7.96726 16.3003C7.60114 16.6663 7.01188 16.6663 5.83337 16.6663C4.65487 16.6663 4.06561 16.6663 3.69949 16.3003C3.33337 15.9341 3.33337 15.3448 3.33337 14.1663V5.83301Z",
    stroke: "#FF7700",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 5.83301C11.6666 4.6545 11.6666 4.06524 12.0327 3.69912C12.3989 3.33301 12.9881 3.33301 14.1666 3.33301C15.3451 3.33301 15.9344 3.33301 16.3005 3.69912C16.6666 4.06524 16.6666 4.6545 16.6666 5.83301V14.1663C16.6666 15.3448 16.6666 15.9341 16.3005 16.3003C15.9344 16.6663 15.3451 16.6663 14.1666 16.6663C12.9881 16.6663 12.3989 16.6663 12.0327 16.3003C11.6666 15.9341 11.6666 15.3448 11.6666 14.1663V5.83301Z",
    stroke: "#FF7700",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedOrange);
export default __webpack_public_path__ + "static/media/pausedOrange.5f167b663fcddb00f90f6e047f33e94f.svg";
export { ForwardRef as ReactComponent };